export enum ResultSizeConstants {
    GetAll = 99999,
    DefaultSearch = 100
}